// ariaLimits.js — SHE OWNS WHAT SHE IS BAD AT, BEFORE SHE SHOWS IT. 2026-08-22.
//
// Braeden: "aria needs to own her strangths and weaknesses, like if shes not
// good at accurate visuals, she can say that before she shows them, so if they
// have a better reference for her to use, shes more than happy to work with it"
//
// A stated weakness is not an apology and not a disclaimer. It is an INVITATION
// — it tells the person which parts to trust, and exactly what to hand her to
// fix the rest. Said BEFORE the artifact, never after, and never only when
// challenged.
//
// THREE rules keep this honest:
//   1. TWO SHORT PARTS, NOT A PARAGRAPH. Braeden 8/22: "she doesnt need to talk
//      so much, just say the first sentance, and the second part — im not
//      accuarte at drawing so if you have an acual plan made, it would work
//      better but heres what i got." One line for the weakness, one for the
//      offer. The first version ran three sentences and read like a legal
//      notice; a limit nobody finishes reading protects nobody.
//   2. NEVER GENERIC. "I might be wrong" teaches nothing. Name the weakness
//      and name the thing that fixes it.
//   3. ONLY WHERE IT IS TRUE. A limit on everything is wallpaper — the same
//      reason a visual on every turn stops being read. Arithmetic she computed
//      and facts served verbatim carry NOTHING.

const LIMITS = {
  // Computed from numbers he gave. She is good at this — say nothing.
  // She is genuinely fine at writing copy, so no hedge - a warning on
  // everything is wallpaper. The DRAFT label already says it is a first pass.
  // Her own checklist - nothing to hedge.
  // A county record is the one thing she can show without hedging.
  record: null,
  case: null,
  draft: null,
  deal: null,

  plan: {
    weak: "These costs are typical, not quoted for your market.",
    better: "Got a real quote? I'll rebuild around it.",
  },

  // Served word for word from the library. Strong — say nothing.
  source: null,

  results: {
    weak: "This is what I could reach, not a source I've verified.",
    better: "Point me at one you trust and I'll use that.",
  },

  guide: {
    weak: "I haven't run these steps myself yet.",
    better: "If you have, tell me how it went and I'll mark it verified.",
  },

  // Owning the gap IS the artifact — nothing to add.
  gap: null,

  // ── the ones he named directly ──────────────────────────────────────────
  blueprint: {
    weak: "I'm not accurate at drawing.",
    better: "If you've got an actual plan, that'd work better — but here's what I got.",
  },
  image: {
    weak: "Accurate images aren't my strength.",
    better: "A reference gets a better result — but here's what I got.",
  },
  estimate_nolocal: {
    weak: "These aren't local numbers.",
    better: "Two local quotes would beat this.",
  },
};

/** The limit for an artifact kind, or null when she is genuinely good at it. */
export function limitFor(kind) {
  return LIMITS[kind] || null;
}

export default LIMITS;
